import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

const propTypes = exact({
  blockName: PropTypes.string,
  fieldID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldValue: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  inputType: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  modifier: PropTypes.string,
  text: PropTypes.string,
});

const defaultProps = {
  blockName: null,
  isChecked: false,
  isDisabled: false,
  isRequired: false,
  modifier: 'ghost',
  text: '',
};

function Checkbox(props) {
  const checkboxClasses = classNames(props.blockName, 'Checkbox', `Checkbox-${props.modifier}`, {
    disabled: props.isDisabled,
  });

  const buttonClasses = classNames('Checkbox_button', {
    'Checkbox_button-checkbox': props.inputType === 'checkbox',
    'Checkbox_button-radio': props.inputType === 'radio',
  });

  return (
    <div className={checkboxClasses}>
      <label htmlFor={props.fieldID} className="Checkbox_label">
        <input
          type={props.inputType}
          id={props.fieldID}
          name={props.fieldName}
          value={props.fieldValue}
          disabled={props.isDisabled}
          required={props.isRequired}
          checked={props.isChecked}
          className="Checkbox_input"
          onChange={props.handleChange}
        />
        <span className={buttonClasses} />
        {`${props.text}${props.isRequired ? '*' : ''}`}
      </label>
    </div>
  );
}

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
